import Vue from 'vue'
import Vuex from 'vuex'
import Parse from 'parse'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    DATA_BLOG : ''
  },
  mutations: {
  },
  actions: {
    getDataBlog() {
      const Posts = Parse.Object.extend('Posts');
      let q = new Parse.Query(Posts)

      q.equalTo('approve', true);
      q.include('author');
      q.include('category');

      q.find().then((obj) => {
        let o = JSON.stringify(obj)
        this.blogs = JSON.parse(o);
        console.log('news :: ', obj);
      }, (err) => {
        console.log(err)
      })
    }
  },
  modules: {
  }
})
